import { MapLike, Networks, WidewakeAdditionalAttributes } from '@iotv/iotv-v3-types'
import { DatastoreObjectType } from '../types'
import { GatewayState } from './IGateway'

export enum GatewayProvisioningState {
  NOT_INVENTORIZED = 'NOT_INVETORIZED',
  INVENTORY = 'INVENTORY',
  ALLOCATED = 'ALLOCATED',
}

export type GatewayProvisioningRecordType = {
  gatewayId?: string
  provisionDate: number
  network?: string
  manager?: string
  groupNames?: string[]
  provisioningState?: GatewayProvisioningState
  inventoryCustomer?: DatastoreObjectType
  allocationCustomer?: DatastoreObjectType
  provisioningUser?: DatastoreObjectType
}

export type GatewayProps = WidewakeAdditionalAttributes & {
  version: string
  regionalPlan: string
  lastSeen?: number
  lastDeviceSeen?: string
  model?: string
  serialNumber?: string
  ports?: number
  channels?: number
  frequency?: number
  _permittedAWOL: number | undefined
  isAWOL?: boolean
  lastSendPeriod?: number
  primaryGatewayUplinkCount?: number
  secondaryGatewayReceiveCount?: number
  gatewayType: string
  billingGroup: string
  appID: string
  networkKey: Networks
  eui: string
  firmwareLevel: string
  batteryLevel: number
  provisioning: GatewayProvisioningRecordType[] // most recent first so that can user provisioning[0] in queries
  state: GatewayState
  //Messages
  messageJoinCount: number
  messageUplinkCount: number
  messageDownlinkCount: number
  messageFailureRate: number
  messageLast: number
  messagePeriodDefault: number
  messagePeriodActual: number
  messageMissingAcceptable: number
}

export type GatewayPropsOptional = Partial<GatewayProps>

export interface IGatewayProps extends GatewayProps {}
